import { AliquotTax } from './aliquot-tax';
import { MedicalAppointmentValidationProcedure } from './medical-appointment-validation-procedure';

export class MedicalAppointmentValidation {
  public EquipmentId?: number;
  public Date?: Date;
  public Id: number;
  public Tax?: number;
  public AliquotTax: AliquotTax;
  public NoValidate?: boolean;
  public PartialValidate?: boolean;
  public MedicalOrderId?: number;
  public OperationTypeId?: number;
  public AuthorizationNumber: string;
  public ReferenceNumber: string;
  public NeedCancel: boolean;
  public Pending: boolean;
  public TransactionReferenceMessage: string;
  public TransactionReferenceNumber: string;
  public DisplayMessage: string;
  public Message: string;
  public Procedures: MedicalAppointmentValidationProcedure[];
  public AgreementPriceIdNoValidated: number[]
}
